<div class="layout-footer">
    <!-- <img src="assets/layout/images/{{layoutService.config().colorScheme === 'light' ? 'logo-dark' : 'logo-white'}}.svg" alt="Logo" height="20" class="mr-2"/> -->
    <img src="assets/taki_ecom.png" alt="Logo" height="20" class="mr-2"/>
</div>
